import {
  Box,
  Typography,
  IconButton,
  Tooltip,
  Chip,
} from '@mui/material'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'

const CarouselList = ({
  carouselList,
  activeStep,
  onSelect,
  onDeleteLocation,
  canDelete,
}) => {
  if (!carouselList?.length) {
    return (
      <Box sx={{ py: 3, px: 1, textAlign: 'center' }}>
        <Typography variant="body2" color="text.secondary">
          No locations for this screen.
        </Typography>
      </Box>
    )
  }

  return (
    <>
      {carouselList.map((item, index) => {
        const isCustom = item.isSystem === false
        const isActive = activeStep === index

        return (
          <Box
            key={item._id}
            onClick={() => onSelect(index, item)}
            sx={{
              p: 1.5,
              borderRadius: 2,
              mb: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: 1,
              cursor: 'pointer',
              border: '1px solid',
              borderColor: isActive ? '#c9a8ff' : 'transparent',
              bgcolor: isActive ? '#f2eaff' : '#fff',
              color: isActive ? '#7A3FFF' : 'inherit',
              fontWeight: isActive ? 600 : 400,
              transition: 'all 0.2s ease-in-out',
              '&:hover': {
                bgcolor: isActive ? '#f2eaff' : '#f7f5fc',
                borderColor: isActive ? '#c9a8ff' : '#ece6f8',
              },
            }}
          >
            <Box sx={{ flex: 1, minWidth: 0 }}>
              <Typography
                variant="body2"
                sx={{ fontWeight: 'inherit', wordBreak: 'break-word' }}
              >
                {item.label || item.location}
              </Typography>
              {isCustom && (
                <Chip
                  label="Custom"
                  size="small"
                  sx={{
                    mt: 0.5,
                    height: 20,
                    fontSize: 11,
                    bgcolor: '#ede7f6',
                    color: '#7A3FFF',
                  }}
                />
              )}
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
              {canDelete && isCustom && (
                <Tooltip title="Delete location">
                  <IconButton
                    size="small"
                    color="error"
                    onClick={(e) => {
                      e.stopPropagation()
                      onDeleteLocation?.(item)
                    }}
                  >
                    <DeleteOutlineIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              )}
              <ChevronRightIcon
                fontSize="small"
                sx={{ color: isActive ? '#7A3FFF' : 'text.disabled' }}
              />
            </Box>
          </Box>
        )
      })}
    </>
  )
}

export default CarouselList
